<template>
    <PanelPage>
        <div>
            <div id="my-tab-content"></div>
            <div>
                <div class="md:grid md:grid-cols-2 md:gap-6">
                    <div>
                        <div class="grid grid-cols-2 md:gap-6">
                            <div>
                                <div class="mb-1 font-semibold">
                                    {{ $t('messages.group_and_subject') }}
                                </div>
                                <div>
                                    <a
                                        style="
                                            padding: 4px 8px;
                                            margin: 4px 8px;
                                            background-color: #4888bb;
                                            color: #fff;
                                            border-radius: 0.25rem;
                                        "
                                        href="javascript:(function(){let div=document.createElement('textarea');div.id ='notas';const tab=document.getElementById('my-tab-content'); tab.prepend(div);})();"
                                    >
                                        {{
                                            $tc('messages.step_X', 1, {
                                                number: 1,
                                            })
                                        }}
                                    </a>
                                </div>

                                <div style="margin-top: 8px">
                                    <a
                                        style="
                                            padding: 4px 8px;
                                            margin: 4px 8px;
                                            background-color: #4888bb;
                                            color: #fff;
                                            border-radius: 0.25rem;
                                        "
                                        href="javascript:(function(){const gradesEl=document.getElementById('notas');const grades=gradesEl.value.split('\n').map(student=>student.split('\t'));const rows=document.querySelectorAll('#my-tab-content tbody tr');const rowsArray=Array.from(rows);const filteredRows=rowsArray.filter(row=>{const select=row.querySelector('td:nth-child(6)>div>div>select');if(select.disabled){return false;}const td=row.querySelector('td:nth-child(1)');if(td.classList.contains('cursiva')){return false;}return true;});for(let i=0;i<grades.length;i++){let studentGrades=grades[i];let row=filteredRows[i];for(let j=0;j<studentGrades.length;j++){if(studentGrades[j]!==''){let grade=studentGrades[j];let x=6+j;let select=row.querySelector(`td:nth-child(${x})>div>div>select`);select.value='string:'+grade.trim();let event=new Event('change');select.dispatchEvent(event);}}}})()"
                                    >
                                        {{
                                            $tc('messages.step_X', 2, {
                                                number: 2,
                                            })
                                        }}
                                    </a>
                                </div>
                            </div>

                            <div>
                                <div class="mb-1 font-semibold">
                                    {{ $t('messages.group_and_student') }}
                                </div>
                                <div>
                                    <a
                                        style="
                                            padding: 4px 8px;
                                            margin: 4px 8px;
                                            background-color: #ff8507;
                                            color: #fff;
                                            border-radius: 0.25rem;
                                        "
                                        href="javascript:(function(){let div=document.createElement('textarea');div.id ='notas';const tab=document.getElementById('my-tab-content'); tab.prepend(div);})();"
                                    >
                                        {{
                                            $tc('messages.step_X', 1, {
                                                number: 1,
                                            })
                                        }}
                                    </a>
                                </div>

                                <div style="margin-top: 8px">
                                    <a
                                        style="
                                            padding: 4px 8px;
                                            margin: 4px 8px;
                                            background-color: #ff8507;
                                            color: #fff;
                                            border-radius: 0.25rem;
                                        "
                                        href="javascript:(function()%7Bvar%20gradesEl%20%3D%20document.getElementById('notas')%3Bvar%20grades%20%3D%20gradesEl.value.split(%22%5Cn%22).map(student%20%3D%3E%20student.split(%22%5Ct%22))%3Bvar%20selects%20%3D%20document.querySelectorAll('div.tab-pane%3Anth-child(3)%20select')%3Bvar%20selectsArray%20%3D%20Array.from(selects)%3Bfor%20(let%20i%20%3D%200%3B%20i%20%3C%20grades.length%3B%20i%2B%2B)%20%7Blet%20studentGrades%20%3D%20grades%5Bi%5D%3Blet%20select%20%3D%20selectsArray%5Bi%5D%3Bfor%20(let%20j%20%3D%200%3B%20j%20%3C%20studentGrades.length%3B%20j%2B%2B)%20%7Bif%20(studentGrades%5Bj%5D%20!%3D%3D%20'')%20%7Blet%20grade%20%3D%20studentGrades%5Bj%5D%3Blet%20x%20%3D%206%20%2B%20j%3Bselect.value%20%3D%20'string%3A'%20%2B%20grade%3Blet%20event%20%3D%20new%20Event('change')%3Bselect.dispatchEvent(event)%3B%7D%7D%7D%7D)()"
                                    >
                                        {{
                                            $tc('messages.step_X', 2, {
                                                number: 2,
                                            })
                                        }}
                                    </a>
                                </div>

                                <!-- This example requires Tailwind CSS v2.0+ -->
                                <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-5">
                                    <div class="flex">
                                        <div class="shrink-0">
                                            <!-- Heroicon name: solid/exclamation -->
                                            <svg
                                                class="h-5 w-5 text-yellow-400"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <div class="ml-3">
                                            <p class="text-sm text-yellow-700">
                                                {{ $t('messages.esfera_warning_message') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {{ $t('messages.instructions') }}:
                        <div style="margin-top: 32px">
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube-nocookie.com/embed/hgOl47VH-TA"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen=""
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div class="bg-white">
                    <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                        <div class="bg-indigo-700 rounded-lg shadow-xl overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
                            <div class="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                                <div class="lg:self-center">
                                    <h2 class="text-3xl font-extrabold text-white sm:text-4xl">
                                        <span class="block">{{
                                            $t('marketing.esfera.if_you_want_to_save_more_time')
                                        }}</span>
                                    </h2>
                                    <a
                                        :href="
                                            `mailto:info@tichit.com?body=` +
                                            $t('marketing.section8.mailto_body') +
                                            `&subject=` +
                                            $t('marketing.section8.mailto_subject')
                                        "
                                        class="mt-8 bg-white border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-indigo-600 hover:bg-indigo-50"
                                    >
                                        {{ $t('marketing.esfera.use_tichit') }}
                                    </a>
                                </div>
                            </div>
                            <div class="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                                <img
                                    class="translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                                    src="/img/landing/screenshots/grading_es.png"
                                    alt="App screenshot"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        PanelPage,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
